export const setEnvironment = () => {
  const user = JSON.parse(localStorage.getItem("user") ?? "{}");

  const baseUrl =
    user?.profile === "PRODUCTION"
      ? process.env.REACT_APP_BASE_URL
      : process.env.REACT_APP_BASE_URL2;

  if (baseUrl?.includes("test")) {
    localStorage.setItem("environment", "TEST");
  } else {
    localStorage.removeItem("environment");
  }
};
